<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Promo2020 from './Promo2020.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */


  /**
   * プロモ2020のアイテム情報を流用する
   * @param {string} id アイテムID
   * @param {ItemInfo} payload アイテム情報に混ぜ込みたい内容
   * @return {ItemInfo} アイテム情報
   * @see {externalItem}
   */
  function promo2020Item (id = '', payload = {}) {
    const { items } = Promo2020.data()
    return externalItem(items, id, payload)
  }

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-05-27',
        major: [
          'PT02',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] WR
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-94',
            rare        : 'WR',
            name        : 'ガールズエールあんなワンピ',
            imgUrl      : '/images/items/PT2-94.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW|GY',
            type        : 'LO|PO',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-95',
            rare        : 'WR',
            name        : 'ガールズエールあんなシューズ',
            imgUrl      : '/images/items/PT2-95.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW|GY',
            type        : 'LO|PO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-96',
            rare        : 'WR',
            name        : 'ガールズエールあんなヘアアクセ',
            imgUrl      : '/images/items/PT2-96.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DW|GY',
            type        : 'LO|PO',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'WR',
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-97',
            rare        : 'WR',
            name        : 'ドーリーワルツえもワンピ',
            imgUrl      : '/images/items/PT2-97.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'DW|GY',
            type        : 'LO|PO',
            point       : 2000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-98',
            rare        : 'WR',
            name        : 'ドーリーワルツえもシューズ',
            imgUrl      : '/images/items/PT2-98.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW|GY',
            type        : 'LO|PO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-99',
            rare        : 'WR',
            name        : 'ドーリーワルツえもヘアアクセ',
            imgUrl      : '/images/items/PT2-99.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DW|GY',
            type        : 'LO|PO',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'WR',
          }),


          // [NOTE] IR
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'IR02-01',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュあんなドレス',
            imgUrl      : '/images/items/IR02-01.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'IR02-02',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュあんなシューズ',
            imgUrl      : '/images/items/IR02-02.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'IR02-03',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュあんなヘアアクセ',
            imgUrl      : '/images/items/IR02-03.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
          }),


          item({
            collection  : 'PT02',
            id          : 'IR02-04',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュさらドレス',
            imgUrl      : '/images/items/IR02-04.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'IR02-05',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュさらシューズ',
            imgUrl      : '/images/items/IR02-05.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'IR02-06',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュさらヘアアクセ',
            imgUrl      : '/images/items/IR02-06.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
          }),


          item({
            collection  : 'PT02',
            id          : 'IR02-07',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュめるドレス',
            imgUrl      : '/images/items/IR02-07.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'IR02-08',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュめるシューズ',
            imgUrl      : '/images/items/IR02-08.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'IR02-09',
            rare        : 'IR',
            name        : 'メロディーファンタジーイルミナージュめるヘアアクセ',
            imgUrl      : '/images/items/IR02-09.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
          }),


          item({
            collection  : 'PT02',
          }),
          promo2020Item('IR02-10', {
            collection  : 'PT02',
            aggregation : '',
          }),
          item({
            collection  : 'PT02',
          }),
          item({
            collection  : 'PT02',
          }),


          // [NOTE] ER
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'ER2-01',
            rare        : 'ER',
            name        : 'クラシックシークレットアリスワンピ',
            imgUrl      : '/images/items/ER2-01.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-02',
            rare        : 'ER',
            name        : 'クラシックシークレットアリスシューズ',
            imgUrl      : '/images/items/ER2-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-03',
            rare        : 'ER',
            name        : 'クラシックシークレットアリスヘアアクセ',
            imgUrl      : '/images/items/ER2-03.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT02',
            id          : 'ER2-04',
            rare        : 'ER',
            name        : 'クラシックミラクル☆キラッツワンピ',
            imgUrl      : '/images/items/ER2-04.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-05',
            rare        : 'ER',
            name        : 'クラシックミラクル☆キラッツシューズ',
            imgUrl      : '/images/items/ER2-05.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-06',
            rare        : 'ER',
            name        : 'クラシックミラクル☆キラッツヘアアクセ',
            imgUrl      : '/images/items/ER2-06.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT02',
            id          : 'ER2-07',
            rare        : 'ER',
            name        : 'キラッとチェックスイートハニーワンピ',
            imgUrl      : '/images/items/ER2-07.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-08',
            rare        : 'ER',
            name        : 'キラッとチェックスイートハニーシューズ',
            imgUrl      : '/images/items/ER2-08.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-09',
            rare        : 'ER',
            name        : 'キラッとチェックスイートハニーヘアアクセ',
            imgUrl      : '/images/items/ER2-09.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT02',
            id          : 'ER2-10',
            rare        : 'ER',
            name        : 'キラッとチェックガールズエールワンピ',
            imgUrl      : '/images/items/ER2-10.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-11',
            rare        : 'ER',
            name        : 'キラッとチェックガールズエールシューズ',
            imgUrl      : '/images/items/ER2-11.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'ER2-12',
            rare        : 'ER',
            name        : 'キラッとチェックガールズエールヘアアクセ',
            imgUrl      : '/images/items/ER2-12.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'ER',
          }),


          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-01',
            rare        : 'FR',
            name        : 'プリ☆ファンファイタートップス',
            imgUrl      : '/images/items/PT2-01.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 1100,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-02',
            rare        : 'FR',
            name        : 'プリ☆ファンファイターパンツ',
            imgUrl      : '/images/items/PT2-02.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 1050,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-03',
            rare        : 'FR',
            name        : 'プリ☆ファンファイターシューズ',
            imgUrl      : '/images/items/PT2-03.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-04',
            rare        : 'FR',
            name        : 'プリ☆ファンファイターヘアアクセ',
            imgUrl      : '/images/items/PT2-04.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-05',
            rare        : 'FR',
            name        : 'プリ☆ファンまほうつかいワンピ',
            imgUrl      : '/images/items/PT2-05.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 2000,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-06',
            rare        : 'FR',
            name        : 'プリ☆ファンまほうつかいシューズ',
            imgUrl      : '/images/items/PT2-06.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-07',
            rare        : 'FR',
            name        : 'プリ☆ファンまほうつかいヘアアクセ',
            imgUrl      : '/images/items/PT2-07.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'FR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-08',
            rare        : 'PR',
            name        : 'サイバーキャットイエロートップス',
            imgUrl      : '/images/items/PT2-08.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-09',
            rare        : 'PR',
            name        : 'サイバーキャットイエロースカート',
            imgUrl      : '/images/items/PT2-09.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-10',
            rare        : 'PR',
            name        : 'サイバーキャットイエローシューズ',
            imgUrl      : '/images/items/PT2-10.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-11',
            rare        : 'PR',
            name        : 'サイバーキャットイエローヘアアクセ',
            imgUrl      : '/images/items/PT2-11.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-12',
            rare        : 'PR',
            name        : 'サイバーキャットピンクトップス',
            imgUrl      : '/images/items/PT2-12.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-13',
            rare        : 'PR',
            name        : 'サイバーキャットピンクパンツ',
            imgUrl      : '/images/items/PT2-13.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-14',
            rare        : 'PR',
            name        : 'サイバーキャットピンクシューズ',
            imgUrl      : '/images/items/PT2-14.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-15',
            rare        : 'PR',
            name        : 'サイバーキャットピンクヘアアクセ',
            imgUrl      : '/images/items/PT2-15.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-16',
            rare        : 'PR',
            name        : 'マスコットメルパントップス',
            imgUrl      : '/images/items/PT2-16.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-17',
            rare        : 'PR',
            name        : 'マスコットメルパンスカート',
            imgUrl      : '/images/items/PT2-17.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-18',
            rare        : 'PR',
            name        : 'マスコットメルパンシューズ',
            imgUrl      : '/images/items/PT2-18.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-19',
            rare        : 'PR',
            name        : 'マスコットメルパンヘアアクセ',
            imgUrl      : '/images/items/PT2-19.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-20',
            rare        : 'PR',
            name        : 'アメリカンダイナーレッドトップス',
            imgUrl      : '/images/items/PT2-20.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-21',
            rare        : 'PR',
            name        : 'アメリカンダイナーレッドスカート',
            imgUrl      : '/images/items/PT2-21.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-22',
            rare        : 'PR',
            name        : 'アメリカンダイナーレッドシューズ',
            imgUrl      : '/images/items/PT2-22.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-23',
            rare        : 'PR',
            name        : 'アメリカンダイナーレッドヘアアクセ',
            imgUrl      : '/images/items/PT2-23.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-24',
            rare        : 'SR',
            name        : 'アメリカンダイナーブルートップス',
            imgUrl      : '/images/items/PT2-24.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-25',
            rare        : 'SR',
            name        : 'アメリカンダイナーブルースカート',
            imgUrl      : '/images/items/PT2-25.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-26',
            rare        : 'SR',
            name        : 'アメリカンダイナーブルーシューズ',
            imgUrl      : '/images/items/PT2-26.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-27',
            rare        : 'SR',
            name        : 'アメリカンダイナーブルーヘアアクセ',
            imgUrl      : '/images/items/PT2-27.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-28',
            rare        : 'SR',
            name        : 'ジュエリーコスメトップス',
            imgUrl      : '/images/items/PT2-28.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-29',
            rare        : 'SR',
            name        : 'ジュエリーコスメスカート',
            imgUrl      : '/images/items/PT2-29.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-30',
            rare        : 'SR',
            name        : 'ジュエリーコスメシューズ',
            imgUrl      : '/images/items/PT2-30.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-31',
            rare        : 'SR',
            name        : 'ジュエリーコスメヘアアクセ',
            imgUrl      : '/images/items/PT2-31.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-32',
            rare        : 'SR',
            name        : 'フレッシュみずぎレモントップス',
            imgUrl      : '/images/items/PT2-32.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-33',
            rare        : 'SR',
            name        : 'フレッシュみずぎレモンスカート',
            imgUrl      : '/images/items/PT2-33.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-34',
            rare        : 'SR',
            name        : 'フレッシュみずぎレモンサンダル',
            imgUrl      : '/images/items/PT2-34.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-35',
            rare        : 'SR',
            name        : 'フレッシュみずぎレモンヘアアクセ',
            imgUrl      : '/images/items/PT2-35.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-36',
            rare        : 'SR',
            name        : 'アイドルキャストクールトップス',
            imgUrl      : '/images/items/PT2-36.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-37',
            rare        : 'SR',
            name        : 'アイドルキャストクールスカート',
            imgUrl      : '/images/items/PT2-37.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-38',
            rare        : 'SR',
            name        : 'アイドルキャストクールシューズ',
            imgUrl      : '/images/items/PT2-38.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-39',
            rare        : 'SR',
            name        : 'アイドルキャストクールヘアアクセ',
            imgUrl      : '/images/items/PT2-39.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-40',
            rare        : 'SR',
            name        : 'チアフルセレモニートップス',
            imgUrl      : '/images/items/PT2-40.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-41',
            rare        : 'SR',
            name        : 'チアフルセレモニースカート',
            imgUrl      : '/images/items/PT2-41.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-42',
            rare        : 'SR',
            name        : 'チアフルセレモニーシューズ',
            imgUrl      : '/images/items/PT2-42.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-43',
            rare        : 'SR',
            name        : 'チアフルセレモニーヘアアクセ',
            imgUrl      : '/images/items/PT2-43.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-55',
            rare        : 'SR',
            name        : 'マスコットメルパンピンクトップス',
            imgUrl      : '/images/items/MF-55.png',
            kind        : '',
            color       : '桃',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-56',
            rare        : 'SR',
            name        : 'マスコットメルパンピンクスカート',
            imgUrl      : '/images/items/MF-56.png',
            kind        : '',
            color       : '桃',
            brand       : 'LP',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-57',
            rare        : 'SR',
            name        : 'マスコットメルパンピンクシューズ',
            imgUrl      : '/images/items/MF-57.png',
            kind        : '',
            color       : '桃',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-58',
            rare        : 'SR',
            name        : 'マスコットメルパンピンクヘアアクセ',
            imgUrl      : '/images/items/MF-58.png',
            kind        : '',
            color       : '水',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-45',
            rare        : 'R',
            name        : 'ネオングラデトップス',
            imgUrl      : '/images/items/PT2-45.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-46',
            rare        : 'R',
            name        : 'ネオングラデスカート',
            imgUrl      : '/images/items/PT2-46.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-47',
            rare        : 'R',
            name        : 'ネオングラデシューズ',
            imgUrl      : '/images/items/PT2-47.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-48',
            rare        : 'R',
            name        : 'ネオングラデヘアアクセ',
            imgUrl      : '/images/items/PT2-48.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-49',
            rare        : 'R',
            name        : 'ブリティッシュチェックトップス',
            imgUrl      : '/images/items/PT2-49.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-50',
            rare        : 'R',
            name        : 'ブリティッシュチェックスカート',
            imgUrl      : '/images/items/PT2-50.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-51',
            rare        : 'R',
            name        : 'ブリティッシュチェックシューズ',
            imgUrl      : '/images/items/PT2-51.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-52',
            rare        : 'R',
            name        : 'ブリティッシュチェックヘアアクセ',
            imgUrl      : '/images/items/PT2-52.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-53',
            rare        : 'R',
            name        : 'ダンスフロアワンピ',
            imgUrl      : '/images/items/PT2-53.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-54',
            rare        : 'R',
            name        : 'ダンスフロアシューズ',
            imgUrl      : '/images/items/PT2-54.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-55',
            rare        : 'R',
            name        : 'ダンスフロアヘアアクセ',
            imgUrl      : '/images/items/PT2-55.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'R',
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-56',
            rare        : 'R',
            name        : 'やきたてベーカリーレッドトップス',
            imgUrl      : '/images/items/PT2-56.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-57',
            rare        : 'R',
            name        : 'やきたてベーカリーレッドスカート',
            imgUrl      : '/images/items/PT2-57.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-58',
            rare        : 'R',
            name        : 'やきたてベーカリーレッドシューズ',
            imgUrl      : '/images/items/PT2-58.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-59',
            rare        : 'R',
            name        : 'やきたてベーカリーレッドヘアアクセ',
            imgUrl      : '/images/items/PT2-59.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-60',
            rare        : 'R',
            name        : 'かいじゅうレインコートイエロートップス',
            imgUrl      : '/images/items/PT2-60.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-61',
            rare        : 'R',
            name        : 'かいじゅうレインコートイエローパンツ',
            imgUrl      : '/images/items/PT2-61.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-62',
            rare        : 'R',
            name        : 'かいじゅうレインコートイエローシューズ',
            imgUrl      : '/images/items/PT2-62.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-63',
            rare        : 'R',
            name        : 'かいじゅうレインコートイエローヘアアクセ',
            imgUrl      : '/images/items/PT2-63.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-64',
            rare        : 'R',
            name        : 'カラフルキューティートップス',
            imgUrl      : '/images/items/PT2-64.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-65',
            rare        : 'R',
            name        : 'カラフルキューティーパンツ',
            imgUrl      : '/images/items/PT2-65.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-66',
            rare        : 'R',
            name        : 'カラフルキューティーシューズ',
            imgUrl      : '/images/items/PT2-66.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-67',
            rare        : 'R',
            name        : 'カラフルキューティーヘアアクセ',
            imgUrl      : '/images/items/PT2-67.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-68',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストレッドトップス',
            imgUrl      : '/images/items/PT2-68.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-69',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストレッドスカート',
            imgUrl      : '/images/items/PT2-69.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-70',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストレッドシューズ',
            imgUrl      : '/images/items/PT2-70.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-71',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストレッドヘアアクセ',
            imgUrl      : '/images/items/PT2-71.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-72',
            rare        : 'R',
            name        : 'ハッピーバカンスネイビートップス',
            imgUrl      : '/images/items/PT2-72.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-73',
            rare        : 'R',
            name        : 'ハッピーバカンスネイビースカート',
            imgUrl      : '/images/items/PT2-73.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-74',
            rare        : 'R',
            name        : 'ハッピーバカンスネイビーシューズ',
            imgUrl      : '/images/items/PT2-74.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-75',
            rare        : 'R',
            name        : 'ハッピーバカンスネイビーヘアアクセ',
            imgUrl      : '/images/items/PT2-75.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-76',
            rare        : 'N',
            name        : 'レインボーサマートップス',
            imgUrl      : '/images/items/PT2-76.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-77',
            rare        : 'N',
            name        : 'レインボーサマースカート',
            imgUrl      : '/images/items/PT2-77.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-78',
            rare        : 'N',
            name        : 'レインボーサマーシューズ',
            imgUrl      : '/images/items/PT2-78.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-79',
            rare        : 'N',
            name        : 'レインボーサマーヘアアクセ',
            imgUrl      : '/images/items/PT2-79.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-80',
            rare        : 'N',
            name        : 'ミステリーブルートップス',
            imgUrl      : '/images/items/PT2-80.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-81',
            rare        : 'N',
            name        : 'ミステリーブルースカート',
            imgUrl      : '/images/items/PT2-81.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-82',
            rare        : 'N',
            name        : 'ミステリーブルーシューズ',
            imgUrl      : '/images/items/PT2-82.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-83',
            rare        : 'N',
            name        : 'ミステリーブルーヘアアクセ',
            imgUrl      : '/images/items/PT2-83.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-84',
            rare        : 'N',
            name        : 'フレンチレースピンクトップス',
            imgUrl      : '/images/items/PT2-84.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-85',
            rare        : 'N',
            name        : 'フレンチレースピンクスカート',
            imgUrl      : '/images/items/PT2-85.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-86',
            rare        : 'N',
            name        : 'フレンチレースピンクシューズ',
            imgUrl      : '/images/items/PT2-86.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-87',
            rare        : 'N',
            name        : 'フレンチレースピンクヘアアクセ',
            imgUrl      : '/images/items/PT2-87.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 350,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-88',
            rare        : 'N',
            name        : 'バルーンミルキーデニムサロペット',
            imgUrl      : '/images/items/PT2-88.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-89',
            rare        : 'N',
            name        : 'バルーンミルキーデニムシューズ',
            imgUrl      : '/images/items/PT2-89.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-90',
            rare        : 'N',
            name        : 'バルーンミルキーデニムヘアアクセ',
            imgUrl      : '/images/items/PT2-90.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'N',
          }),


          item({
            collection  : 'PT02',
            id          : 'PT2-91',
            rare        : 'N',
            name        : 'ラブリーステッチブルーワンピ',
            imgUrl      : '/images/items/PT2-91.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-92',
            rare        : 'N',
            name        : 'ラブリーステッチブルーシューズ',
            imgUrl      : '/images/items/PT2-92.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            id          : 'PT2-93',
            rare        : 'N',
            name        : 'ラブリーステッチブルーヘアアクセ',
            imgUrl      : '/images/items/PT2-93.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            rare        : 'N',
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'PT02',
            id          : 'PT2-44',
            rare        : 'SR',
            name        : 'チーズたっぷりピザ',
            imgUrl      : '/images/items/PT2-44.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT02',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-72',
            rare        : 'SR',
            name        : 'サンシャインみずぎトップス',
            imgUrl      : '/images/items/PB-72.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-73',
            rare        : 'SR',
            name        : 'サンシャインみずぎスカート',
            imgUrl      : '/images/items/PB-73.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-74',
            rare        : 'SR',
            name        : 'サンシャインみずぎシューズ',
            imgUrl      : '/images/items/PB-74.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-75',
            rare        : 'SR',
            name        : 'サンシャインみずぎヘアアクセ',
            imgUrl      : '/images/items/PB-75.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-76',
            rare        : 'SR',
            name        : 'ぐるぐるチャイナトップス',
            imgUrl      : '/images/items/PB-76.png',
            kind        : '',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-77',
            rare        : 'SR',
            name        : 'ぐるぐるチャイナスカート',
            imgUrl      : '/images/items/PB-77.png',
            kind        : '',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-78',
            rare        : 'SR',
            name        : 'ぐるぐるチャイナシューズ',
            imgUrl      : '/images/items/PB-78.png',
            kind        : '',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-79',
            rare        : 'SR',
            name        : 'ぐるぐるチャイナヘアアクセ',
            imgUrl      : '/images/items/PB-79.png',
            kind        : '',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          promo2020Item('P-NC-006', {
            collection  : 'プレゼントボックス',
            id          : 'PB-80',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            aggregation : '',
          }),
          promo2020Item('P-NC-006-S', {
            collection  : 'プレゼントボックス',
            id          : 'PB-81',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            aggregation : '',
          }),
          promo2020Item('P-NC-006-H', {
            collection  : 'プレゼントボックス',
            id          : 'PB-82',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            aggregation : '',
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'HR',
          }),


          item({
            collection  : 'プレゼントボックス',
            id          : 'PB-83',
            rare        : 'SR',
            name        : 'ぷり。がくぶち',
            imgUrl      : '/images/items/PB-83.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'SR',
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'SR',
          }),
          item({
            collection  : 'プレゼントボックス',
            rare        : 'SR',
          }),


          // [NOTE] フレッシュみずぎチャンネル
          // ================================================================================

          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-100',
            rare        : 'SR',
            name        : 'フレッシュみずぎオレンジトップス',
            imgUrl      : '/images/items/PT2-100.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-101',
            rare        : 'SR',
            name        : 'フレッシュみずぎオレンジスカート',
            imgUrl      : '/images/items/PT2-101.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-102',
            rare        : 'SR',
            name        : 'フレッシュみずぎオレンジサンダル',
            imgUrl      : '/images/items/PT2-102.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-103',
            rare        : 'SR',
            name        : 'フレッシュみずぎオレンジヘアアクセ',
            imgUrl      : '/images/items/PT2-103.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-104',
            rare        : 'SR',
            name        : 'フレッシュみずぎピングレトップス',
            imgUrl      : '/images/items/PT2-104.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-105',
            rare        : 'SR',
            name        : 'フレッシュみずぎピングレスカート',
            imgUrl      : '/images/items/PT2-105.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-106',
            rare        : 'SR',
            name        : 'フレッシュみずぎピングレサンダル',
            imgUrl      : '/images/items/PT2-106.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'フレッシュみずぎチャンネル',
            id          : 'PT2-107',
            rare        : 'SR',
            name        : 'フレッシュみずぎピングレヘアアクセ',
            imgUrl      : '/images/items/PT2-107.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] すみっコぐらしチャンネル
          // ================================================================================

          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-111',
            rare        : 'SR',
            name        : 'すみっコぐらしうみっコワンピ',
            imgUrl      : '/images/items/PT2-111.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-112',
            rare        : 'SR',
            name        : 'すみっコぐらしうみっコシューズ',
            imgUrl      : '/images/items/PT2-112.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-113',
            rare        : 'SR',
            name        : 'すみっコぐらしうみっコヘアアクセ',
            imgUrl      : '/images/items/PT2-113.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-114',
            rare        : 'SR',
            name        : 'すみっコぐらしうみっコサンセットワンピ',
            imgUrl      : '/images/items/PT2-114.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-115',
            rare        : 'SR',
            name        : 'すみっコぐらしうみっコサンセットシューズ',
            imgUrl      : '/images/items/PT2-115.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-116',
            rare        : 'SR',
            name        : 'すみっコぐらしうみっコサンセットヘアアクセ',
            imgUrl      : '/images/items/PT2-116.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'すみっコぐらしチャンネル',
            id          : 'PT2-117',
            rare        : 'SR',
            name        : 'すみっコぐらしとかげ',
            imgUrl      : '/images/items/PT2-117.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'すみっコぐらしチャンネル',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ラブパトリーナチャンネル
          // ================================================================================

          item({
            collection  : 'ラブパトリーナチャンネル',
            id          : 'PT2-108',
            rare        : 'SR',
            name        : 'ラブパトピンクツバサワンピ',
            imgUrl      : '/images/items/PT2-108.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ラブパトリーナチャンネル',
            id          : 'PT2-109',
            rare        : 'SR',
            name        : 'ラブパトピンクツバサシューズ',
            imgUrl      : '/images/items/PT2-109.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ラブパトリーナチャンネル',
            id          : 'PT2-110',
            rare        : 'SR',
            name        : 'ラブパトピンクツバサヘアアクセ',
            imgUrl      : '/images/items/PT2-110.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ラブパトリーナチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-118',
            rare        : 'SR',
            name        : 'オールフレンズドレシシオンワンピ',
            imgUrl      : '/images/items/PT2-118.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-119',
            rare        : 'SR',
            name        : 'オールフレンズドレシシオンシューズ',
            imgUrl      : '/images/items/PT2-119.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-120',
            rare        : 'SR',
            name        : 'オールフレンズドレシシオンヘアアクセ',
            imgUrl      : '/images/items/PT2-120.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-121',
            rare        : 'SR',
            name        : 'オールフレンズドレシドロシーワンピ',
            imgUrl      : '/images/items/PT2-121.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-122',
            rare        : 'SR',
            name        : 'オールフレンズドレシドロシーシューズ',
            imgUrl      : '/images/items/PT2-122.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-123',
            rare        : 'SR',
            name        : 'オールフレンズドレシドロシーヘアアクセ',
            imgUrl      : '/images/items/PT2-123.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-124',
            rare        : 'SR',
            name        : 'オールフレンズドレシレオナワンピ',
            imgUrl      : '/images/items/PT2-124.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-125',
            rare        : 'SR',
            name        : 'オールフレンズドレシレオナシューズ',
            imgUrl      : '/images/items/PT2-125.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            id          : 'PT2-126',
            rare        : 'SR',
            name        : 'オールフレンズドレシレオナヘアアクセ',
            imgUrl      : '/images/items/PT2-126.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリティーオールフレンズチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-01',
            rare        : 'PR',
            name        : 'サイバーキャットグリーントップス',
            imgUrl      : '/images/items/NC-PT2-01.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 900,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-02',
            rare        : 'PR',
            name        : 'サイバーキャットグリーンスカート',
            imgUrl      : '/images/items/NC-PT2-02.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-PT2-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-03',
            rare        : 'PR',
            name        : 'サイバーキャットグリーンシューズ',
            imgUrl      : '/images/items/NC-PT2-03.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            aggregation : 'NC-PT2-01',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-04',
            rare        : 'PR',
            name        : 'サイバーキャットグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-04.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-PT2-01',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-05',
            rare        : 'PR',
            name        : 'アメリカンダイナーイエロートップス',
            imgUrl      : '/images/items/NC-PT2-05.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-06',
            rare        : 'PR',
            name        : 'アメリカンダイナーイエロースカート',
            imgUrl      : '/images/items/NC-PT2-06.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            aggregation : 'NC-PT2-05',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-07',
            rare        : 'PR',
            name        : 'アメリカンダイナーイエローシューズ',
            imgUrl      : '/images/items/NC-PT2-07.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-PT2-05',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-08',
            rare        : 'PR',
            name        : 'アメリカンダイナーイエローヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-08.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-PT2-05',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-09',
            rare        : 'SR',
            name        : 'ジュエリーコスメブルートップス',
            imgUrl      : '/images/items/NC-PT2-09.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-10',
            rare        : 'SR',
            name        : 'ジュエリーコスメブルースカート',
            imgUrl      : '/images/items/NC-PT2-10.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            aggregation : 'NC-PT2-09',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-11',
            rare        : 'SR',
            name        : 'ジュエリーコスメブルーシューズ',
            imgUrl      : '/images/items/NC-PT2-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-PT2-09',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-12',
            rare        : 'SR',
            name        : 'ジュエリーコスメブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-12.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-PT2-09',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-13',
            rare        : 'SR',
            name        : 'チアフルセレモニーピンクトップス',
            imgUrl      : '/images/items/NC-PT2-13.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-14',
            rare        : 'SR',
            name        : 'チアフルセレモニーピンクスカート',
            imgUrl      : '/images/items/NC-PT2-14.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            aggregation : 'NC-PT2-13',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-15',
            rare        : 'SR',
            name        : 'チアフルセレモニーピンクシューズ',
            imgUrl      : '/images/items/NC-PT2-15.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT2-13',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-16',
            rare        : 'SR',
            name        : 'チアフルセレモニーピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-16.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT2-13',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-17',
            rare        : 'SR',
            name        : 'フライングスカイつばめトップス',
            imgUrl      : '/images/items/NC-PT2-17.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-18',
            rare        : 'SR',
            name        : 'フライングスカイつばめパンツ',
            imgUrl      : '/images/items/NC-PT2-18.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT2-17',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-19',
            rare        : 'SR',
            name        : 'フライングスカイつばめシューズ',
            imgUrl      : '/images/items/NC-PT2-19.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT2-17',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-20',
            rare        : 'SR',
            name        : 'フライングスカイつばめヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-20.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DS',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT2-17',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-21',
            rare        : 'SR',
            name        : 'フライングスカイスワントップス',
            imgUrl      : '/images/items/NC-PT2-21.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-22',
            rare        : 'SR',
            name        : 'フライングスカイスワンパンツ',
            imgUrl      : '/images/items/NC-PT2-22.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            aggregation : 'NC-PT2-21',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-23',
            rare        : 'SR',
            name        : 'フライングスカイスワンシューズ',
            imgUrl      : '/images/items/NC-PT2-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-PT2-21',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-24',
            rare        : 'SR',
            name        : 'フライングスカイスワンヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-24.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-PT2-21',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-25',
            rare        : 'R',
            name        : 'やきたてベーカリーオレンジトップス',
            imgUrl      : '/images/items/NC-PT2-25.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-26',
            rare        : 'R',
            name        : 'やきたてベーカリーオレンジスカート',
            imgUrl      : '/images/items/NC-PT2-26.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT2-25',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-27',
            rare        : 'R',
            name        : 'やきたてベーカリーオレンジシューズ',
            imgUrl      : '/images/items/NC-PT2-27.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-25',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-28',
            rare        : 'R',
            name        : 'やきたてベーカリーオレンジヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-28.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-25',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-29',
            rare        : 'R',
            name        : 'やきたてベーカリーブルートップス',
            imgUrl      : '/images/items/NC-PT2-29.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-30',
            rare        : 'R',
            name        : 'やきたてベーカリーブルースカート',
            imgUrl      : '/images/items/NC-PT2-30.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT2-29',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-31',
            rare        : 'R',
            name        : 'やきたてベーカリーブルーシューズ',
            imgUrl      : '/images/items/NC-PT2-31.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-29',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-32',
            rare        : 'R',
            name        : 'やきたてベーカリーブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-32.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-29',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-33',
            rare        : 'R',
            name        : 'スクールガーリーピュアトップス',
            imgUrl      : '/images/items/NC-PT2-33.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-34',
            rare        : 'R',
            name        : 'スクールガーリーピュアスカート',
            imgUrl      : '/images/items/NC-PT2-34.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT2-33',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-35',
            rare        : 'R',
            name        : 'スクールガーリーピュアシューズ',
            imgUrl      : '/images/items/NC-PT2-35.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-33',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-36',
            rare        : 'R',
            name        : 'スクールガーリーピュアヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-36.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-33',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-37',
            rare        : 'R',
            name        : 'スクールハンサムピュアトップス',
            imgUrl      : '/images/items/NC-PT2-37.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-38',
            rare        : 'R',
            name        : 'スクールハンサムピュアパンツ',
            imgUrl      : '/images/items/NC-PT2-38.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-37',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-39',
            rare        : 'R',
            name        : 'スクールハンサムピュアシューズ',
            imgUrl      : '/images/items/NC-PT2-39.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-37',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-40',
            rare        : 'R',
            name        : 'スクールハンサムピュアヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-40.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-37',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-41',
            rare        : 'R',
            name        : 'スクールガーリーノーブルトップス',
            imgUrl      : '/images/items/NC-PT2-41.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-42',
            rare        : 'R',
            name        : 'スクールガーリーノーブルスカート',
            imgUrl      : '/images/items/NC-PT2-42.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT2-41',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-43',
            rare        : 'R',
            name        : 'スクールガーリーノーブルシューズ',
            imgUrl      : '/images/items/NC-PT2-43.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-41',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-44',
            rare        : 'R',
            name        : 'スクールガーリーノーブルヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-44.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-41',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-45',
            rare        : 'R',
            name        : 'スクールハンサムノーブルトップス',
            imgUrl      : '/images/items/NC-PT2-45.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-46',
            rare        : 'R',
            name        : 'スクールハンサムノーブルパンツ',
            imgUrl      : '/images/items/NC-PT2-46.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-45',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-47',
            rare        : 'R',
            name        : 'スクールハンサムノーブルシューズ',
            imgUrl      : '/images/items/NC-PT2-47.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-45',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-48',
            rare        : 'R',
            name        : 'スクールハンサムノーブルヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-48.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-45',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-49',
            rare        : 'R',
            name        : 'かいじゅうレインコートグリーントップス',
            imgUrl      : '/images/items/NC-PT2-49.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-50',
            rare        : 'R',
            name        : 'かいじゅうレインコートグリーンパンツ',
            imgUrl      : '/images/items/NC-PT2-50.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-49',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-51',
            rare        : 'R',
            name        : 'かいじゅうレインコートグリーンシューズ',
            imgUrl      : '/images/items/NC-PT2-51.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-49',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-52',
            rare        : 'R',
            name        : 'かいじゅうレインコートグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-52.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-49',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-53',
            rare        : 'R',
            name        : 'かいじゅうレインコートレッドトップス',
            imgUrl      : '/images/items/NC-PT2-53.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-54',
            rare        : 'R',
            name        : 'かいじゅうレインコートレッドパンツ',
            imgUrl      : '/images/items/NC-PT2-54.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-53',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-55',
            rare        : 'R',
            name        : 'かいじゅうレインコートレッドシューズ',
            imgUrl      : '/images/items/NC-PT2-55.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-53',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-56',
            rare        : 'R',
            name        : 'かいじゅうレインコートレッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-56.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-53',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-57',
            rare        : 'R',
            name        : 'クラブストライプパープルトップス',
            imgUrl      : '/images/items/NC-PT2-57.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-58',
            rare        : 'R',
            name        : 'クラブストライプパープルスカート',
            imgUrl      : '/images/items/NC-PT2-58.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-57',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-59',
            rare        : 'R',
            name        : 'クラブストライプパープルシューズ',
            imgUrl      : '/images/items/NC-PT2-59.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-57',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-60',
            rare        : 'R',
            name        : 'クラブストライプパープルヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-60.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-57',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-61',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストパープルトップス',
            imgUrl      : '/images/items/NC-PT2-61.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-62',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストパープルスカート',
            imgUrl      : '/images/items/NC-PT2-62.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-61',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-63',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストパープルシューズ',
            imgUrl      : '/images/items/NC-PT2-63.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-61',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-64',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストパープルヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-64.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-61',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-65',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストグリーントップス',
            imgUrl      : '/images/items/NC-PT2-65.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-66',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストグリーンスカート',
            imgUrl      : '/images/items/NC-PT2-66.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-65',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-67',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストグリーンシューズ',
            imgUrl      : '/images/items/NC-PT2-67.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-65',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-68',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-68.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-65',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-69',
            rare        : 'R',
            name        : 'ネオングラデフレッシュトップス',
            imgUrl      : '/images/items/NC-PT2-69.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-70',
            rare        : 'R',
            name        : 'ネオングラデフレッシュスカート',
            imgUrl      : '/images/items/NC-PT2-70.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT2-69',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-71',
            rare        : 'R',
            name        : 'ネオングラデフレッシュシューズ',
            imgUrl      : '/images/items/NC-PT2-71.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-69',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-72',
            rare        : 'R',
            name        : 'ネオングラデフレッシュヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-72.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT2-69',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-73',
            rare        : 'R',
            name        : 'カラフルキューティーさわやかトップス',
            imgUrl      : '/images/items/NC-PT2-73.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-74',
            rare        : 'R',
            name        : 'カラフルキューティーさわやかパンツ',
            imgUrl      : '/images/items/NC-PT2-74.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT2-73',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-75',
            rare        : 'R',
            name        : 'カラフルキューティーさわやかシューズ',
            imgUrl      : '/images/items/NC-PT2-75.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-73',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-76',
            rare        : 'R',
            name        : 'カラフルキューティーさわやかヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-76.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'CH',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-73',
          }),


          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-77',
            rare        : 'R',
            name        : 'ピンクチェックレディートップス',
            imgUrl      : '/images/items/NC-PT2-77.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-78',
            rare        : 'R',
            name        : 'ピンクチェックレディースカート',
            imgUrl      : '/images/items/NC-PT2-78.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT2-77',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-79',
            rare        : 'R',
            name        : 'ピンクチェックレディーシューズ',
            imgUrl      : '/images/items/NC-PT2-79.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-77',
          }),
          item({
            collection  : 'ニコチケ',
            id          : 'NC-PT2-80',
            rare        : 'R',
            name        : 'ピンクチェックレディーヘアアクセ',
            imgUrl      : '/images/items/NC-PT2-80.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT2-77',
          }),

        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsIR () {
        return _.where(this.itemsMaJor, { rare: 'IR' })
      },

      itemsWR () {
        return _.where(this.itemsMaJor, { rare: 'WR' })
      },

      itemsER () {
        return _.where(this.itemsMaJor, { rare: 'ER' })
      },

      itemsFR () {
        return _.where(this.itemsMaJor, { rare: 'FR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'プレゼントボックス' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsFMChannel () {
        return _.where(this.itemsFiltered, { collection: 'フレッシュみずぎチャンネル' })
      },

      itemsSGChannel () {
        return _.where(this.itemsFiltered, { collection: 'すみっコぐらしチャンネル' })
      },

      itemsLPChannel () {
        return _.where(this.itemsFiltered, { collection: 'ラブパトリーナチャンネル' })
      },

      itemsAllFriends () {
        return _.where(this.itemsFiltered, { collection: 'プリティーオールフレンズチャンネル' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'ニコチケ' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
    </template>

    <template #col2>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col5>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
    </template>

    <template #col6>
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#a1c0fa" :items="itemsAllFriends" />
    </template>

    <template #col7>
      <ItemList title="フレッシュみずぎチャンネル" color="#a1c0fa" :items="itemsFMChannel" />
      <ItemList title="すみっコぐらしチャンネル" color="#a1c0fa" :items="itemsSGChannel" />
      <ItemList title="ラブパトリーナチャンネル" color="#a1c0fa" :items="itemsLPChannel" />
    </template>

    <template #col8>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col9>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(7 * 4)" />
    </template>

    <template #col10>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(7 * 4)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // // コレクショングループ間の間隔 (IR)
  // .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
  //   .Item:nth-child(13),
  //   .Item:nth-child(14),
  //   .Item:nth-child(15),
  //   .Item:nth-child(16) {
  //     margin-top: $size-unit * 8;
  //   }
  // }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 470;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 10;
    }
  }
</style>
